import { Component, OnInit } from '@angular/core';
import { ApiService } from '@services/api.service';
import ApexCharts from 'apexcharts';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  ChartDataPilot: any = {};
  ChartDataOwner: any = {};

  ChartData2: any = {
    yearly: {
      data: [0, 50, 0, 520, 200],
      categories: ["2021", "2022", "2023", "2024", "2025"]
    },
    monthly: {
      data: [0, 30, 150, 10, 90, 120, 50, 40, 700, 250, 300, 330],
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    },
    weekly: {
      data: [3, 40, 30, 25, 20, 210, 100, 150],
      categories: ["W1", "W2", "W3", "W4", "W5", "W6", "W7", "W8"]
    }
  };
  dashStatistics: any;
  constructor(private apiService: ApiService
  ) {


  }

  ngOnInit(): void {
    this.getPilotTrend();
    this.getOwnerTrend();
    this.getStatistics();
  }
  getStatistics() {
    this.apiService.getStatistics().subscribe({
      next: (response: any) => {
        if (response.status_code == 200) {
          this.dashStatistics = response.data
          this.dashStatistics.total_admin_payouts = Number(this.dashStatistics.total_admin_payouts.replace(/,/g, ''));
          this.dashStatistics.total_pilot_payments = Number(this.dashStatistics.total_pilot_payments.replace(/,/g, ''));
          this.dashStatistics.total_owner_payments = Number(this.dashStatistics.total_owner_payments.replace(/,/g, ''));

        }
      },
      error: (err) => {
        console.error('Failed to load owners', err);
      }
    });
  }
  getPilotTrend() {
    this.apiService.getPilotTrend().subscribe({
      next: (response: any) => {
        if (response.status_code == 200) {
          this.ChartDataPilot = response?.data
        }
      },
      error: (err) => {
        console.error('Failed to load owners', err);
      }
    });
  }
  getOwnerTrend() {
    this.apiService.getOwnerTrend().subscribe({
      next: (response: any) => {
        if (response.status_code == 200) {
          this.ChartDataOwner = response?.data
        }
      },
      error: (err) => {
        console.error('Failed to load owners', err);
      }
    });
  }
  getSubscriptionTrend() {
    this.apiService.getPilotTrend().subscribe({
      next: (response: any) => {
        if (response.status_code == 200) {
          this.ChartDataPilot = response?.data
        }
      },
      error: (err) => {
        console.error('Failed to load owners', err);
      }
    });
  }
}
